var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityQuestionFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8 1.59998C44.0139 1.59998 50.9323 4.46568 56.0333 9.56667C61.1343 14.6677 64 21.5861 64 28.8C64 36.0139 61.1343 42.9323 56.0333 48.0333C50.9323 53.1343 44.0139 56 36.8 56H35.2V59.168C35.2 59.5927 35.1163 60.0132 34.9537 60.4055C34.791 60.7979 34.5527 61.1543 34.2522 61.4545C33.9518 61.7546 33.5951 61.9926 33.2026 62.1549C32.8101 62.3171 32.3895 62.4004 31.9648 62.4C24.0928 62.3936 16.1184 59.7664 10.0672 54.3872C3.9616 48.9536 0.0064 40.88 0 30.4288V28.8C0 21.5861 2.86571 14.6677 7.9667 9.56667C13.0677 4.46568 19.9861 1.59998 27.2 1.59998H36.8ZM20.8 24C19.527 24 18.3061 24.5057 17.4059 25.4059C16.5057 26.306 16 27.5269 16 28.8C16 30.073 16.5057 31.2939 17.4059 32.1941C18.3061 33.0943 19.527 33.6 20.8 33.6C22.073 33.6 23.2939 33.0943 24.1941 32.1941C25.0943 31.2939 25.6 30.073 25.6 28.8C25.6 27.5269 25.0943 26.306 24.1941 25.4059C23.2939 24.5057 22.073 24 20.8 24ZM43.2 24C41.927 24 40.7061 24.5057 39.8059 25.4059C38.9057 26.306 38.4 27.5269 38.4 28.8C38.4 30.073 38.9057 31.2939 39.8059 32.1941C40.7061 33.0943 41.927 33.6 43.2 33.6C44.473 33.6 45.6939 33.0943 46.5941 32.1941C47.4943 31.2939 48 30.073 48 28.8C48 27.5269 47.4943 26.306 46.5941 25.4059C45.6939 24.5057 44.473 24 43.2 24Z",
    fill: "#44484E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityQuestionFeed);
export default __webpack_public_path__ + "static/media/CommunityQuestionFeed.d3402089956ec6e27a1c7479a8bf45ae.svg";
export { ForwardRef as ReactComponent };